const initialState = {
  locale: "fr",
  kiosk: null
};

export default function(state = initialState, action) {
  if (action.type === "SWITCH_LOCALE") {
    return {
      ...state,
      locale: action.locale
    };
  } else if (action.type === "SET_KIOSK") {
    return {
      ...state,
      kiosk: action.kiosk
    };
  }

  return state;
}
